exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".body{margin:0 10%}.center{text-align:center}.tcTitle{font-weight:400}.sdgTitle{font-size:45px}.titleBold{font-weight:700}ul{list-style:none;padding-left:0}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/PrivacyPolicy/PrivacyPolicy.vue"],"names":[],"mappings":"AACA,MACI,YAAc,CACjB,AACD,QACI,iBAAmB,CACtB,AACD,SACI,eAAmB,CACtB,AACD,UACI,cAAgB,CACnB,AACD,WACI,eAAkB,CACrB,AACD,GACI,gBAAiB,AACjB,cAAgB,CACnB","file":"PrivacyPolicy.vue","sourcesContent":["\n.body {\n    margin: 0 10%;\n}\n.center {\n    text-align: center;\n}\n.tcTitle{\n    font-weight:normal;\n}\n.sdgTitle{\n    font-size: 45px;\n}\n.titleBold{\n    font-weight: bold;\n}\nul {\n    list-style: none;\n    padding-left: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d1ddade","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PrivacyPolicy/PrivacyPolicy.vue
// module id = 505
// module chunks = 16